export const ARTICLE_PUBLISHED_DATE_FORMAT = 'dd MMM';
export const ARTICLE_PUBLISHED_DATE_DETAILED_FORMAT = 'dd MMM yyyy';
